import Sentry from 'sentry';

global.WOGE = {
    branch: 'woge',
    bjr: 1900,
    dry: true,
    o_possible: true,
    type: 'woge',

    canCalc: function() {
	WOGE.o_possible = WOGE.haveRisk() && WOGE.chkWF() && WOGE.havePeril();
	JQ('#b_' + WOGE.type + '_go2datavn').button("option", "disabled", ! WOGE.o_possible);
	if (parseInt(JQ('#f_'+WOGE.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+WOGE.type+'_rbt_bundle_text').val().length === 0 || !PHVO.o_possible) {
		JQ('#b_' + WOGE.type + '_go2datavn').button("option", "disabled", true);
		JQ('#f_'+WOGE.type+'_rbt_bundle_text').focus();
	} else {
		JQ('#b_' + WOGE.type + '_go2datavn').button("option", "disabled", false);
	}
	if (ALL.data && ALL.data.branch) WOGE.o_possible = WOGE.o_possible && ALL.chkSET();
	PRIV.calcable = WOGE.o_possible;
	BC.debug('WOGE.canCalc(): =>', PRIV.calcable, 64);
	ALL.notifyHeight();
	return WOGE.o_possible;
    },

    change: function(e) {
	BC.debug('WOGE.change()', '...starting...', 64);
	if (! ALL.mobile) {
	    JQ('#f_woge_f_1').prop('disabled', false);
	    if (! WOGE.canCalc()) {
		ALL.chgProduct('woge', null);
		ALL.notifyHeight();
		return false;
	    }
	    JQ('#div_woge_vers').show();
	    WOGE.recalc();
	    ALL.notifyHeight();
	    return true;
	}
	WOGE.recalc();
	ALL.notifyHeight();
	return true;
    },

    chgWF2: function() {
        if (JQ('#f_' + WOGE.type + '_wf2').val() &&
            JQ('#f_' + WOGE.type + '_wf2').val() != JQ('#f_' + WOGE.type + '_wf').val() &&
            WOGE.canCalc()) {
            JQ('#f_' + WOGE.type + '_wf').val(JQ('#f_' + WOGE.type + '_wf2').val());
            WOGE.change();
        }
        if (JQ('#f_' + WOGE.type + '_plz2').val() &&
            JQ('#f_' + WOGE.type + '_plz2').val() != JQ('#f_' + WOGE.type + '_plz').val() &&
            WOGE.canCalc()) {
            JQ('#f_' + WOGE.type + '_plz').val(JQ('#f_' + WOGE.type + '_plz2').val()).change();
            WOGE.change();
        }
    },

    chkDA: function(div) {
	// Kann DA/Antrag geposted werden?
	BC.debug('WOGE.chkDA() starting in div', div, 64);
        var needed;
        if (div == 4)
            needed = {vv0  : [true, 'Angabe frühere Antragsablehungen fehlt'],
                      vv1  : [true, 'Angabe, ob eine Vorversicherung bestand, fehlt'],
                      vv1a : [false, 'Erläuterung für nicht vorhandene Vorversicherung in den letzten 5 Jahren fehlt.'],
                      vv2  : [false, 'Angabe, wer den Vorversicherungsvertrag gekündigt hat, fehlt.'],
		      vv3  : [true, 'Name der Vorversicherungsgesellschaft fehlt.'],
		      vv4  : [true, 'Nummer des Vorversicherungsvertrages fehlt.'],
		      vv5  : [true, 'Ablaufdatum des Vorversicherungsvertrages.'],
		      vv6a : [false, 'Beschreibung, Höhe und Datum des Vorschadens fehlen.'],};
        else
            needed = {iban : [false, 'IBAN fehlt.']};

	JQ('#btn_da_ok').button('disable');

        // Frühere (abgelehnte) Anträge:
        if (div == 4) {
	    if (JQ('#f_da_vv0_1').is(':checked')) {
	        ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund vorheriger Antrags-Ablehnungen bei der Waldenburger leider nicht möglich.', true);
	        return false;
	    } else if (! JQ('#f_da_vv0_0').is(':checked')) {
                return false;
            }
	    if (JQ('#f_da_vv2_2').is(':checked')) {
	        ALL.showHint('Die Übernahme des Versicherungsschutzes ist aufgrund der Kündigung durch den Vorversicherer bei der Waldenburger leider nicht möglich.', true);
	        return false;
	    }
            // Angaben Vorversicherung:
	    if (JQ('#f_da_vv1_1').is(':checked')) {
	        // Es bestand eine Vorversicherung
	        JQ('#div_da_vv2').show();
	        needed.vv2[0] = true;
	        JQ('#div_da_vv3').show();
	        needed.vv3[0] = true;
	        JQ('#div_da_vv4').show();
	        needed.vv4[0] = true;
	        JQ('#div_da_vv5').show();
	        needed.vv5[0] = true;
	        JQ('#div_da_vv1a').hide();
	        needed.vv1a[0] = false;
	    } else if (JQ('#f_da_vv1_0').is(':checked')) {
	        // Es bestand keine Vorversicherung
	        JQ('#div_da_vv2').hide();
	        needed.vv2[0] = false;
	        JQ('#div_da_vv3').hide();
	        needed.vv3[0] = false;
	        JQ('#div_da_vv4').hide();
	        needed.vv4[0] = false;
	        JQ('#div_da_vv5').hide();
	        needed.vv5[0] = false;
	        BC.debug('WOGE.chkDA(): Vorversicherungsfrage - ', 'NON Unfall', 64);
	        JQ('#div_da_vv1a').show();
	        needed.vv1a[0] = true;
	        if (JQ(this).prop('id') === 'f_da_vv1_0') ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld kurz, warum in den letzten ' + PRIV.vv_yy + ' Jahren kein Versicherungsschutz vorhanden war.');
	    } else {
                // Frage Vorversicherung nicht beantwortet
                return false;
            }
            ALL.notifyHeight();
	    // Anzahl Vorschäden in den letzten 5 bzw. 10 Jahren
	    if (JQ('#f_da_vv6').length) {
                BC.debug('WOGE.chkDA() - f_da_vv6: ' + JQ('#f_da_vv6').val() + ' Vorschäden', this, 64);
	        if (JQ('#f_da_vv6').val() === '0') {
		    // Keine Vorschäden
		    JQ('#div_da_vv6a').hide();
		    ALL.notifyHeight();
		    needed.vv6a[0] = false;
	        } else if (JQ('#f_da_vv6').val() === '1') {
		    // Ein Vorschaden, Erläuterung benötigt
		    JQ('#div_da_vv6a').show();
		    ALL.notifyHeight();
		    needed.vv6a[0] = true;
		    if (! ALL.mobile && ! JQ('#f_da_vv6a').val()) ALL.showHint('Bitte erläutern Sie in dem entsprechenden Feld den Schaden inkl. Schadenjahr und Schadenhöhe.');
	        } else if (JQ('#f_da_vv6').val() !== '0' && JQ('#f_da_vv6').val() !== '1') {
		    JQ('#div_da_vv6a').hide();
		    ALL.notifyHeight();
		    ALL.showHint('Die Übernahme des Versicherungsschutzes durch die Waldenburger Versicherung ist bei mehr als einem Vorschaden in den vergangenen Jahren leider nicht möglich.', true);
		    return false;
	        }
	    }
        } else if (div == 5) {
	    if (JQ('#f_da_za_1').is(':checked')) {
	        // Zahlung per Lastschrift, Konto benötigt
	        JQ('#div_da_iban').show();
	        needed.iban[0] = true;
	    } else {
	        // Zahlung per Rechnung, kein Konto benötigt
	        JQ('#div_da_iban').hide();
	        needed.iban[0] = false;
	    }
        }
        ALL.notifyHeight();
	JQ.each(needed, function (k, v) {
	    BC.debug('WOGE.chkDA() - Looping through ', [k, v], 64);
	    // Prüfe nochmals, ob alle erforderlichen Felder (var needed) gefüllt sind.
	    // Aber nur, wenn die Felder keine options sind, dafür erfolgt die Prüfung
	    // separat.
	    if (JQ('#f_da_' + k + '_0').length || JQ('#f_da_' + k + '_1').length) return true;
	    if (v[0] && ! JQ('#f_da_' + k).val()) {
		if (! ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
		JQ('#f_da_' + k).prop('required', true).focus();
		PRIV.canDA = false;
		BC.debug('WOGE.chkDA() - Missing info for #f_da_' + k, v[1], 64);
		return false;
	    } else if (v[0] && JQ('#f_da_' + k).val()) {
		PRIV.canDA = true;
	    } else {
		JQ('#f_da_' + k).prop('required', false);
	    }
	});
        //if (div == 4) return true;
        //PRIV.canDA = false;
	if (div == 5 &&
            JQ('#f_da3_0').is(':checked') &&
	    JQ('#f_da3_1').is(':checked') &&
	    JQ('#f_da3_2').is(':checked') &&
	    (! JQ('#f_da3_3').length ||
	     JQ('#f_da3_3').is(':checked'))) {
	    // Alle Bestätigungen im letzten Block vorhanden!
	    // Prüfe einzelne Felder
	    if (needed.iban[0] &&
		(! JQ('#f_da_iban').val() ||
		 ! JQ('#f_da_levok').is(':checked'))) {
                BC.debug('WOGE.chkDA(), Missing IBAN', this, 64);
		//ALL.showHint('Die IBAN und/oder das SEPA-Mandat sind nicht ausgefüllt.');
		PRIV.canDA = false;
		return false;
	    } else if (needed.iban[0] &&
                       JQ('#f_da_levok').is(':checked') &&
                       JQ('#f_da_iban').val() &&
                       chk_iban(JQ('#f_da_iban').val()) != '1') {
		ALL.showHint('Die IBAN ist nicht korrekt, bitte überprüfen Sie die Eingabe.');
		PRIV.canDA = false;
		return false;
	    }
            if (div == 4) {
	        if (! JQ('#f_da_vv0_0').is(':checked') && ! JQ('#f_da_vv0_1').is(':checked')) {
		    ALL.showHint('Bitte geben Sie an, ob in der Vergangenheit Anträge auf Versicherungsschutz abgelehnt wurden.');
		    PRIV.canDA = false;
		    return false;
	        }
	        if (! JQ('#f_da_vv1_0').is(':checked') && ! JQ('#f_da_vv1_1').is(':checked')) {
		    ALL.showHint('Bitte geben Sie an, ob eine Vorversicherung bestand.');
		    PRIV.canDA = false;
		    return false;
	        }
	        if (needed.vv2[0] && ! JQ('#f_da_vv2_1').is(':checked') && ! JQ('#f_da_vv2_2').is(':checked')) {
		    ALL.showHint('Bitte geben Sie an, durch wen die Vorversicherung gekündigt wurde.');
		    PRIV.canDA = false;
		    return false;
	        }
            }
	    JQ.each(needed, function (k, v) {
		BC.debug('WOGE.chkDA() - Looping through ', [k, v], 64);
		// Prüfe nochmals, ob alle erforderlichen Felder (var needed) gefüllt sind.
		// Aber nur, wenn die Felder keine options sind, dafür erfolgt die Prüfung
		// separat.
		if (JQ('#f_da_' + k + '_0').length || JQ('#f_da_' + k + '_1').length) return true;
		if (v[0] && ! JQ('#f_da_' + k).val()) {
		    if (! ALL.mobile) ALL.showHint('Die Verarbeitung des Antrags ist nicht möglich: ' + v[1]);
		    JQ('#f_da_' + k).prop('required', true).focus();
		    PRIV.canDA = false;
		    BC.debug('WOGE.chkDA() - Missing info for #f_da_' + k, v[1], 64);
		    return false;
		} else if (v[0] && JQ('#f_da_' + k).val()) {
		    PRIV.canDA = true;
		} else {
		    BC.debug('WOGE.chkDA() - Problem with ' + k + ', Unsetting required', v[1], 64);
		    JQ('#f_da_' + k).prop('required', false);
		    PRIV.canDA = true;
		}
	    });
	    if (ALL.mobile && (! PRIV.an_read || ! PRIV.wd_read)) {
		PRIV.canDA = false;
		ALL.showHint('Bitte öffnen Sie mittels obiger Links das Angebot und/oder laden die Bedingungen herunter.');
		JQ('#f_da3_1').attr('checked', false)
		return PRIV.canDA;
	    } else if (! PRIV.an_read) {
                //PRIV.canDA = false;
		PRIV.canDA = ! WALDI;
                BC.debug('WOGE.chkDA(): Offer not downloaded', '', 64);
                //ALL.showHint('Bitte laden Sie das Angebot herunter.')
		return PRIV.canDA;
            }
	    BC.debug('WOGE.chkDA():', [PRIV.canDA, needed], 64);
	    if (PRIV.canDA) {
		JQ('#btn_da_ok').button('enable');
		JQ('#f_da_set').val(1);
	    }
	}
	BC.debug('WOGE.chkDA() ends:', [PRIV.canDA, needed], 64);
	return PRIV.canDA;
    },

    chkDivReady: function(btn) {
	var r;
        BC.debug('WOGE.chkDivReady():', btn, 64);
	try {
	    var b = BC.get_id(btn);
            var p = ALL.get_box_id(b);
            if (! p) return false;
	    var d = BC.get_id(p);
	}
	catch (e) {
	    BC.debug('WOGE.chkDivReady() rised an exception:', e, 16);
		Sentry.captureException(e);
	    return false;
	}
        if (! d) return false;
	BC.debug('WOGE.chkDivReady() called for ' + b + ' in ' + d, btn, 64);
        ALL.chkDivReady(d, true);
	switch(d) {
	case '#div_0':
	    return true;
	case '#div_1':
	    if (JQ('#f_' +  WOGE.type + '_plz').val() &&
		JQ('#f_' +  WOGE.type + '_wf').val()) {
		BC.debug('WOGE.chkDivReady(): ' + d + ' is ready!', '', 64);
		JQ('#f_woge_plz2').val(JQ('#f_woge_plz').val());
		JQ('#f_woge_wf2').val(JQ('#f_woge_wf').val());
		return true;
	    }
	    ALL.chgMobButton('#btn_fwd_1', false);
	    break;
	case '#div_2':
	    if ((JQ('#f_' +  WOGE.type + '_itype_1').is(':checked') ||
		 JQ('#f_' +  WOGE.type + '_itype_2').is(':checked')) &&
		JQ('#f_' +  WOGE.type + '_ggn_0').is(':checked') &&
		JQ('#f_' +  WOGE.type + '_dmg_0').is(':checked') &&
		JQ('#f_' +  WOGE.type + '_ded_1').is(':checked')) {
		BC.debug('WOGE.chkDivReady(): ' + d + ' is ready!', '', 64);
		ALL.steps[1] = 3;
		return true;
	    }
	    ALL.chgMobButton('#btn_fwd_2', false);
	    break;
	case '#div_3':
		if (parseInt(JQ('#f_'+WOGE.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+WOGE.type+'_rbt_bundle_text').val().length === 0) {
			JQ('#vs-nr-hint-woge').show();
		} else {
			JQ('#vs-nr-hint-woge').hide();
		}
		ALL.notifyHeight();
	    if ((JQ('#f_' +  WOGE.type + '_plus_0').is(':checked') ||
		 JQ('#f_' +  WOGE.type + '_plus_1').is(':checked')) &&
		ALL.isVNcompleted() && ALL.haveVN() &&
		ALL.steps[1] >= 3) {
		if (parseInt(JQ('#f_'+WOGE.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+WOGE.type+'_rbt_bundle_text').val().length === 0) {
			ALL.chgMobButton('#btn_fwd_3', false);
		} else {
			ALL.steps[1] = 4;
			return true;
		}
		// ALL.steps[1] = 4;
		BC.debug('WOGE.chkDivReady(): ' + d + ' is ready!', '', 64);
	    }
		ALL.chgMobButton('#btn_fwd_3', false);
	    break;
	case '#div_4':
	    PRIV.canDA = false;
	    r = WOGE.chkDA(4);
	    BC.debug('WOGE.chkDivReady(): #div_4 ready is', r, 64);
	    if (r) return true;
	    BC.debug('WOGE.chkDivReady(): #div_4 is NOT ready!', '', 64);
	    ALL.chgMobButton('#btn_fwd_4', false);
            break;
	case '#div_5':
	    PRIV.canDA = false;
            WOGE.setChkFlds();
	    r = WOGE.chkDA(5);
	    BC.debug('WOGE.chkDivReady(): #div_5 ready is', r, 64);
	    if (r) return true;
	    BC.debug('WOGE.chkDivReady(): #div_5 is NOT ready!', '', 64);
	    ALL.chgMobButton('#btn_fwd_5', false);
            break;
	case '#div_98':
	    return true;
	case '#div_99':
            JQ('#div_'  +  WOGE.type + '_rslt').hide();

		ALL.triggerDataLayerEvent('Wohngebäude', WOGE.type);
	    return true;
	default:
	    BC.debug('WOGE.chkDivReady() switch to default, BAD THING [tm]:', d, 16);
	    break;
	}
	BC.debug('WOGE.chkDivReady(): ' + d + ' is NOT ready!', '', 64);
	return false;
    },

    chkKeys: function(e) {
	BC.debug('WOGE.chkKeys(): called', e, 64);
	var plz = JQ('#f_' + WOGE.type + '_plz').val();
	var wf = JQ('#f_' + WOGE.type + '_wf').val();
        var plzi, wfi;
	BC.debug('WOGE.chkKeys(): key pressed: ' + e.key +
		  ' plz.len=' + plz.length + ' wf.len=' + wf.length, '', 64);
	try {
	    plzi = parseInt(plz);
	    wfi  = parseInt(wf);
	}
	catch(e) {
	    BC.debug('WOGE.chkKeys(): raised exception:', e, 64);
	    wfi = 0;
	    plzi = 0;
	}
        if (plz.length == 5 && plzi > 1000) {
            BC.debug('WOGE.chkKeys(): Moving focus to WF', '', 64);
            JQ('#f_' + WOGE.type + '_wf').focus();
        }
	if (! isNaN(plzi) && ! isNaN(wfi) && plz.length == 5 && wf.length >= 2 && plzi >= 1000 && plzi <= 99999) {
            if (wfi >= 75 && wfi <= 250) {
	        BC.debug('WOGE.chkKeys(): 1st calc is possible!', '', 64);
	        ALL.chgMobButton('#btn_fwd_1', true);
	        WOGE.change();
	        return;
	    } else {
	        BC.debug('WOGE.chkKeys(): 1st calc is NOT possible!', '', 64);
		ALL.chgProduct(WOGE.type, 0);
            }
        }
	ALL.chgMobButton('#btn_fwd_1', false);
    },

    chkWF: function(e) {
	// WFs > 250 qm muessen nach 1914er-Tarif versichert werden!
	BC.debug('WOGE.chkWF(): called', e, 64);
	if (JQ('#f_woge_w14').length && ! JQ('#f_woge_w14').val()) JQ('#f_woge_w14').val(0);
	var woge_wf = parseInt(JQ('#f_' + WOGE.type + '_wf').val());
	if (woge_wf > 250) {
            //e.stopPropagation();
	    ALL.showHint('Wohngebäude mit einer Wohnfläche von mehr als 250 qm können leider nicht online tarifiert werden. Bitte wenden Sie sich für ein Angebot an die Waldenburger info@waldenburger.com. Die Wohnfläche für die Online-Berechnung wurde angepasst.');

            JQ('#f_' + WOGE.type + '_wf').val(250);
            JQ('#f_' + WOGE.type + '_wf2').val(250);
	} else if (woge_wf > 25 && woge_wf < 75) {
            //e.stopPropagation();
	    ALL.showHint('Wohngebäude mit einer Wohnfläche von weniger als 75 qm sind bei der Waldenburger nicht versicherbar, daher wurde die Wohnfläche angepasst.');
            JQ('#f_' + WOGE.type + '_wf').val(75);
            JQ('#f_' + WOGE.type + '_wf2').val(75);
        }
        return true;
    },

    chkWF2: function(e) {
	BC.debug('WOGE.chkWF2(): called', e, 64);
	var woge_wf = parseInt(JQ('#f_' + WOGE.type + '_wf').val());
	if (woge_wf > 250) {
	    ALL.showHint('Wohngebäude: Die Wohnfläche darf maximal 250 qm betragen.');
	    JQ('#f_' + WOGE.type + '_wf').val(250);
	    //return false;
	} else if (woge_wf < 75) {
	    ALL.showHint('Wohngebäude: Die Wohnfläche muss mindestens 75 qm betragen.');
	    JQ('#f_' + WOGE.type + '_wf').val(75);
	    //return false;
        }
        JQ('#f_' + WOGE.type + '_wf2').val(JQ('#f_' + WOGE.type + '_wf').val());
    },

    havePeril: function() {
	BC.debug('WOGE.havePeril(): Checking ...', '', 64);
	var valid = true;
	//if (ALL.mobile) return valid;
	var _pv = false;
	var _bjr = parseInt(JQ('#f_woge_bjr').val());
	var _pvbjr = parseInt(JQ('#f_woge_pvbjr').val());
	PRIV.bparts['woge'] = [];
	JQ('.display-on-esg_woge').hide();
    if (JQ("#f_woge_esg").is(':checked') && JQ('#f_woge_esg').val() == '1' && PRIV.bparts['woge'].indexOf('esg') < 0) {
	    PRIV.bparts['woge'].push('esg');
        JQ('.display-on-esg_woge').show();
	}
	ALL.notifyHeight();
	if (! ALL.mobile && ! JQ("#f_woge_f_1").is(':checked')) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte mindestens Feuer als zu versichernde Gefahr angeben.', 1);
		BC.debug('WOGE.havePeril(): Missing woge_f', null, 64);
	    }
	    valid = false;
	    JQ('#div_woge_vers_1').hide();
	    ALL.notifyHeight();
	    return valid;
	}
	JQ('#div_woge_vers_1').show();
	if (valid && JQ("#f_woge_pv_1").is(':checked')) {
	    _pv = true;
	    JQ('#div_woge_pvbjr').show();
            if (! JQ('#f_woge_pvbjr').val()) {
                if (year - _bjr < 10) {
                    _pvbjr = _bjr;
                    JQ('#f_woge_pvbjr').val(_pvbjr);
                } else {
                    ALL.showHint('Bitte Baujahr der Photovoltaik-Anlage eingeben.');
                    valid = false;
                }
            } else {
                _pvbjr = parseInt(JQ('#f_woge_pvbjr').val());
            }
	    JQ('#div_woge_pv').attr('class', 'tab');
	} else {
	    _pv = false;
	    JQ('#div_woge_pvbjr').hide();
	    JQ('#div_woge_pv').attr('class', 'tab lrow');
	}
	if (valid && _pv && (year - _pvbjr) > 10) {
	    BC.debug('WOGE.havePeril(): pvbjr nicht vorhanden oder zu klein:', _pvbjr, 64);
	    ALL.showHint('Die Photovoltaikanlage ist zu alt, um sie online zu versichern. Diese zu versichernde Gefahr wurde daher abgewählt.');
	    JQ('#f_woge_pv_1').prop('checked', false);
	    JQ('#f_woge_pv_0').prop('checked', true);
            JQ('#f_woge_pvbjr').val('');
	}
	ALL.notifyHeight();
	return valid;
    },

    haveRisk: function() {
	BC.debug('WOGE.haveRisk(): Checking ...', '', 64);
	// valid = true : Alle Risikomerkmale vorhanden
	var valid = true;
	var _plz = parseInt(JQ('#f_woge_plz').val());
	var _str = JQ('#f_woge_str').val();
	var _hnr = JQ('#f_woge_hnr').val();
	var _wf = parseInt(JQ('#f_woge_wf').val());
	if (ALL.mobile && _plz && _wf) return true;
	WOGE.bjr = parseInt(JQ('#f_woge_bjr').val());
	if (! _plz) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte die PLZ angeben.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_plz', null, 64);
	    }
	    valid = false;
	}
	if (! _str) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte die Strasse (ohne Hausnummer) eingeben.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_str', null, 64);
	    }
	    valid = false;
	}
	if (! _hnr) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte die Hausnummer eingeben.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_hnr', null, 64);
	    }
	    valid = false;
	}
	if (! _wf || isNaN(_wf)) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte die Wohnfläche eingeben.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_wf', null, 64);
	    }
	    valid = false;
	} else if (_wf < 75) {
	    ALL.showHint('Wohngebäude: Die Wohnfläche muss mindestens 75 qm betragen.');
	    JQ('#f_woge_wf').val(75);
	} else if (_wf > 250) {
	    ALL.showHint('Wohngebäude: Die Wohnfläche darf maximal 250 qm betragen.');
	    JQ('#f_woge_wf').val(250);
	}
	if (! WOGE.bjr || WOGE.bjr <= 1900) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte das Baujahr eingeben.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_bjr', null, 64);
	    }
	    valid = false;
	}
	if (valid && (year - WOGE.bjr) > 20) {
	    // PremiumPlus anfragepflichtig!
	    JQ('#f_woge_plus_1').prop('disabled', true).prop('checked', false);
	    JQ('#f_woge_plus_0').prop('disabled', true).prop('checked', true);
	} else if (valid) {
	    JQ('#f_woge_plus_1').prop('disabled', false);
	    JQ('#f_woge_plus_0').prop('disabled', false);
	}
	//if (valid && (year - _bjr) > 10) {
	//   // Photovoltaik anfragepflichtig!
	//    JQ('#f_woge_plus_1');
	//}
		if (parseInt(JQ('#f_'+WOGE.type+'_rbt_bundle').find('option:selected').val()) >= 5 && JQ('#f_'+WOGE.type+'_rbt_bundle_text').val().length === 0) {
			JQ('#vs-nr-hint-' + WOGE.type).show();
		} else {
			JQ('#vs-nr-hint-' + WOGE.type).hide();
		}
	if (! JQ("#div_woge_risk input[name='woge_auw']").is(':checked')) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte die Bauartklasse angeben.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_auw', null, 64);
	    }
	    valid = false;
	}
	if (! JQ("#div_woge_risk input[name='woge_ded']").is(':checked')) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte die Bauart der Bedachung angeben.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_ded', null, 64);
	    }
	    valid = false;
	}
	if (! JQ("#div_woge_risk input[name='woge_ggn']").is(':checked')) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte angeben, ob es sich um ein gemischt genutztes Gebäude handelt.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_ggn', null, 64);
	    }
	    valid = false;
	}
	if (! JQ("#div_woge_risk input[name='woge_dmg']").is(':checked')) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte angeben, ob es sich um ein denkmalgeschütztes Gebäude handelt.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_dmg', null, 64);
	    }
	    valid = false;
	}
	if (! JQ("#div_woge_risk input[name='woge_sbg']").is(':checked')) {
	    if (! WOGE.dry) {
		ALL.showHint('Wohngebäude: Bitte angeben, ob sich ein Schwimmbad im Gebäude befindet.', 1);
		BC.debug('WOGE.haveRisk(): Missing woge_sbg', null, 64);
	    }
	    valid = false;
	}
	if (valid) {
	    JQ('#f_woge_f_1').prop('disabled', false);
	} else {
	    JQ('#f_woge_f_1').prop({disabled: true, checked: false});
	}
	ALL.notifyHeight();
	return valid;
    },

    init: function() {
        BC.debug('WOGE.init()', null, 64);
        PRIV.hideLogoutAndAdministration();
    	if(isEsg && isEsg === 1) {
    		JQ("#f_"+WOGE.type+"_esg").prop('checked', true)
		}
		PRIV.createBundleRabattFieldsForBranch('woge')
        if (ALL.mobile && ALL.branch.slice(0, 4) != WOGE.branch) return;
		BC.debug('WOGE.init():', '', 64);
		JQ('#div_woge_vers').change(WOGE.change);
		if (! ALL.mobile) {
			ALL.chgProduct('woge', null);
		} else if (! JQ('#div_woge_vers').length) {
				return;
			}
		ALL.chgProduct(WOGE.type, null);
		ALL.chgMobButton('#btn_fwd_1', false);
		JQ('#f_' + WOGE.type + '_wf').change(WOGE.chkWF2);
		JQ('#f_' + WOGE.type + '_wf2').change(WOGE.chgWF2);
		JQ('#f_' + WOGE.type + '_plz2').change(WOGE.chgWF2);
		JQ('#f_' + WOGE.type + '_plz').keyup(WOGE.chkKeys);
		JQ('#f_' + WOGE.type + '_wf').keyup(WOGE.chkKeys);
        JQ('#f_' + WOGE.type + '_start').val(tomorrow);
        JQ('#f_' + WOGE.type + '_ende').val(tomorrowInOneYear);
        JQ('.box input').keyup(ALL.chkDivReady2);
        if (JQ('#f_' + WOGE.type + '_dnls').length &&
            JQ('#f_' + WOGE.type + '_dnls').is(':checked')) JQ('#f_' + WOGE.type + '_ende').val(in3year);
		JQ('#a_da_wording').click(function() {
			PRIV.wd_read=true;
			ALL.chkDivReady('a_da_wording', true);
			ALL.chgMobButtons(ALL.branch);
		});
		ALL.notifyHeight();
    },

    recalc: function(e) {
	BC.debug('WOGE.recalc():', '', 256);
	if (! WOGE.canCalc()) {
	    BC.debug('WOGE.recalc():', 'Cannot calc - check logs!', 16);
	    return;
	}
	var sa = PRIV.make_sa('woge');
	BC.debug('WOGE.recalc():', sa, 64);
	JQ.getJSON(JSONURI, sa, PRIV.setPremium);
	ALL.chkContactData();
    },

    reset: function() {
	BC.debug('WOGE.reset()', '...starting...', 64);
	WOGE.change();
    },

    setChkFlds: function () {
	// Belege Felder in "Angaben überprüfen"
	// Aufruf teilweise in ALL.set_HNR
	if (! ALL.mobile) return;
        JQ('#m098_vo').text(ALL.adr.plz + ' ' + ALL.adr.ort + ', ' +
                            ALL.adr.str + ' ' + ALL.adr.hnr);
	JQ('#m098_wf').text(JQ('#f_' + WOGE.type + '_wf').val());
	JQ('#m098_bjr').text(JQ('#f_' + WOGE.type + '_bjr').val());
	JQ('#m098_itype').text(JQ('#f_' + WOGE.type + '_itype_1').is(':checked') ?
			       'Einfamilienhaus' : 'Mehrfamilienhaus mit max. 3 Wohnungen');
	var _auws = {'1': 'massiv',
		     '2': 'Fachwerk I',
		     '3': 'Fachwerk II',
		     '4': 'Fertighaus'};
	var _auw = JQ('#div_' + WOGE.type + '_auw input[name="woge_auw"]').val();
	JQ('#m098_auw').text(_auws[_auw]);
	JQ('#m098_plus').text(JQ('#f_' + WOGE.type + '_plus_0').is(':checked') ? 'Nein' : 'Ja');
	JQ('#m098_lw').text(JQ('#f_' + WOGE.type + '_lw_1').is(':checked') ? 'Ja' : 'Nein');
	JQ('#m098_sth').text(JQ('#f_' + WOGE.type + '_sth_1').is(':checked') ? 'Ja' : 'Nein');
	JQ('#m098_el').text(JQ('#f_' + WOGE.type + '_el_1').is(':checked') ? 'Ja' : 'Nein');
	if (JQ('#f_' + WOGE.type + '_pv_1').is(':checked')) {
	    JQ('#m098_pv').text('Ja');
	    JQ('#div098_pvbjr').show();
	    JQ('#m098_pvbjr').text(JQ('#f_' + WOGE.type + '_pvbjr').val());
	} else {
	    JQ('#m098_pv').text('Nein');
	    JQ('#div098_pvbjr').hide();
	    JQ('#m098_pvbjr').text('0000');
	}
        ALL.setChkFlds(WOGE.type);
    },

    setPremium: function(data) {
	BC.debug('WOGE.setPremium():', data, 64);
 	ALL.chkError(data);
	if (data.ERROR) {
	    return;
	}
	JQ.each(data, function(key, val) {
	    if (key == 'DirA' && val && val.length) {
		PRIV.setDirAnfrage(val);
		return;
	    } else if (JQ('#f_woge_' + key).length) {
		JQ("#f_woge_" + key).text(val.str);
	    }
	    if (key == 'mpr2' && val.val) {
		JQ('#l_woge_net2').text('Jährliche Nettoprämie Wohngebäudeversicherung (Mindestprämie!):');
	    } else if (key == 'mpr2') {
		JQ('#l_woge_net2').text('Jährliche Nettoprämie Wohngebäudeversicherung:');
	    }
	    if (key == 'brt1' && val.str) {
		ALL.chgProduct('woge', val.str);
	    }
	});
    }
};
